import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Splash from "./Splash";

import './styles/layout.css';
import './styles/map.css';
import './styles/react-datetime.css';
import './styles/splash-screen.css';
import './styles/cesium.css';

import i18n from "./i18n";

import * as dotenv from 'dotenv';

import Op3_calc from "./lib/GLOBAL_STATE/Op3_calc";

dotenv.config();
// console.log(Cesium);

window.__GlobalState = {};

window.OP3_CALC = new Op3_calc();

ReactDOM.render(<Splash />, document.getElementById("root"));

i18n.on('loaded', function(loaded) {
	setTimeout(() => {
		ReactDOM.render(<App/>, document.getElementById("root"));
	}, 500);
})
